import {MainException} from 'common/exception/MainException';
import {ExceptionContract} from 'common/exception/ExceptionContract';

export class ExternalApiException extends MainException implements ExceptionContract {
    public constructor(message: string, data?: {[key: string]: any}) {
        super(message, 502, data);
        this.name = 'ExternalApiException';
    }
}
